"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SequenceFilter = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Remove_1 = require("../../../Button/Remove");
const Wrapper_1 = require("../../../Form/Field/Wrapper");
const Icon_1 = require("../../../Icon");
const _1 = require(".");
require("./index.scss");
const SequenceFilter = (props) => {
    const { value, setValue, hidden } = props;
    if (hidden)
        return null;
    return (react_1.default.createElement("div", { className: `${_1.className}__form` },
        react_1.default.createElement("div", { className: `${_1.className}__reset-sequence` },
            react_1.default.createElement(Wrapper_1.FormFieldWrapper, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:SequenceLabel', defaultMessage: 'Sequence' }), slot: react_1.default.createElement("div", { className: `${_1.className}__sequence` },
                    react_1.default.createElement("div", { className: `${_1.className}__sequence-icon` },
                        react_1.default.createElement(Icon_1.Icon, { name: 'repeat' })),
                    react_1.default.createElement("div", { className: `${_1.className}__sequence-name` }, value),
                    react_1.default.createElement(Remove_1.RemoveButton, { text: '', right: true, onClick: () => setValue === null || setValue === void 0 ? void 0 : setValue(undefined) })) }))));
};
exports.SequenceFilter = SequenceFilter;
//# sourceMappingURL=SequenceFilter.js.map